import { Component, Input } from '@angular/core';
import { OrderHistory } from 'entities/order-history';

@Component({
    selector: 'order-customer',
    templateUrl: './order-customer.component.html',
    styles: [],
    standalone: false
})
export class OrderCustomerComponent {
  @Input() orderInfo: OrderHistory;

  constructor() { }

}
